import Vuex from 'vuex'
import codes from './modules/codes'
import confirmModal from './modules/confirm-modal'
import documentDetail from './modules/document-detail'
import documentAdd from './modules/document-add'
import pageMessage from './modules/page-message'
import product from './modules/product'
import pdfPreview from './modules/pdfPreview'
import productAdd from './modules/product-add'
import sendCart from './modules/send-cart'
/* 20230315 一括送信カート画面のため追加 */
import multiSendCart from './modules/multi-send-cart'
import sendMail from './modules/send-mail'
import sendDetail from './modules/send-detail'
import loginUser from './modules/login-user'
import recipientMaster from './modules/recipient-master'
import transactionHistory from './modules/transaction-history'
import productDetails from './modules/product-details'
import userInfo from './modules/user-info'
import folderInfo from './modules/folder-info'
import productList from './modules/product-list'
import corporateInfoEdit from './modules/corporate-info-edit'
import confirmApiKey from './modules/api-key'
import bulkRevisionSendEditMode from './modules/bulk-revision-send-edit'
import bulkFileUpload from './modules/bulk-file-upload'
import directCorpList from './modules/direct-corp-list'
import directSend from './modules/direct-send'

const store = new Vuex.Store({
  modules: {
    codes,
    confirmModal,
    documentDetail,
    documentAdd,
    pageMessage,
    product,
    pdfPreview,
    productAdd,
    sendCart,
    /* 20230315 一括送信カート画面のため追加 */
    multiSendCart,
    sendMail,
    sendDetail,
    loginUser,
    recipientMaster,
    transactionHistory,
    productDetails,
    productList,
    userInfo,
    folderInfo,
    corporateInfoEdit,
    confirmApiKey,
    bulkRevisionSendEditMode,
    bulkFileUpload,
    directCorpList,
    directSend,
  },
})

export default store
